import React, { useState, forwardRef } from 'react';
import { Copy, Check } from 'lucide-react';
import { Button } from './button';
import { cn } from 'src/lib/utils';

type CopyButtonProps = {
  text: string;
  className?: string;
  iconSize?: number;
  timeout?: number;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export const CopyButton = forwardRef<HTMLButtonElement, CopyButtonProps>(
  (
    { text, className = '', iconSize = 14, timeout = 1000, onClick, ...props },
    ref,
  ) => {
    const [isCopied, setIsCopied] = useState(false);

    const handleCopy = async (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      e.stopPropagation();

      try {
        await navigator.clipboard.writeText(text);
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), timeout);
      } catch (err) {
        console.error('Failed to copy text:', err);
      }

      // Call the original onClick if it exists
      if (onClick) {
        onClick(e);
      }
    };

    return (
      <Button
        ref={ref}
        variant="ghost"
        size="icon"
        onClick={handleCopy}
        className={cn('hover:bg-transparent hover:text-[#0584C3]', className)}
        {...props}
      >
        {isCopied ? (
          <Check width={iconSize} height={iconSize} />
        ) : (
          <Copy width={iconSize} height={iconSize} />
        )}
      </Button>
    );
  },
);

CopyButton.displayName = 'CopyButton';
